import { IDisplayItem, IScreenDesignDictionary, SpecialDIIds } from "@kuika/kuika-cl-model";
import { ScreenDesignHelper } from "../../../../shared/utility/screen-design-helper";

/** One step of the selection breadcrumb, root first. */
export interface ISelectionCrumb {
  kuikaId: string;
  /** Friendly name ("Button1"); the screen's own name for the root. */
  name: string;
  /** Component type ("Button"); "Screen" for the root. */
  type: string;
}

export interface ICollapsedPath {
  /** Crumbs before the ellipsis. */
  head: ISelectionCrumb[];
  /** Ancestors folded behind the ellipsis, root-side first; empty means no ellipsis. */
  hidden: ISelectionCrumb[];
  /** Crumbs after the ellipsis, ending with the selected component. */
  tail: ISelectionCrumb[];
}

/** A corrupt tree with a parent cycle must not hang the overlay. */
const MAX_DEPTH: number = 256;

const ROOT_KUIKA_ID: string = SpecialDIIds.rootDI.toString();

/** Ancestors of `kuikaId` from the screen root down to the component itself; empty when it is unknown. */
export function buildSelectionPath(
  kuikaId: string,
  dict: IScreenDesignDictionary,
  screenName: string
): ISelectionCrumb[] {
  const path: ISelectionCrumb[] = [];
  let current: IDisplayItem | undefined = dict[parseInt(kuikaId, 10)];
  let depth: number = 0;
  while (current && depth < MAX_DEPTH) {
    const id: string = current.id.toString();
    if (id === ROOT_KUIKA_ID) {
      path.unshift({ kuikaId: id, name: screenName || "Screen", type: "Screen" });
      break;
    }
    path.unshift({ kuikaId: id, name: ScreenDesignHelper.getFriendlyName(id, dict), type: current.item?.name ?? "" });
    current = current.parentId !== undefined && current.parentId !== null ? dict[current.parentId] : undefined;
    depth += 1;
  }
  return path;
}

/** The bar's breadcrumb: every ancestor behind the ellipsis, then the selected component. */
export function compactSelectionPath(path: ISelectionCrumb[]): ICollapsedPath {
  if (path.length === 0) {
    return { head: [], hidden: [], tail: [] };
  }
  return { head: [], hidden: path.slice(0, -1), tail: path.slice(-1) };
}
